interface FormItemValidation {
    validateStatus?: "success" | "warning" | "error" | "validating";
    hasFeedback?: boolean;
    help?: string;
}

type ErrorValue = undefined | string | CustomError;

type ErrorMap<T extends string> = Record<T, ErrorValue>;

function getErrorMessage(error: ErrorValue): undefined | string {
    return typeof error === "string" ? error : error?.getErrorMessage();
}

interface CustomError {
    getErrorMessage(): string;
}

export type { ErrorMap, ErrorValue, CustomError, FormItemValidation };

export { getErrorMessage };
